import { benchModels, benchShapes, stoves } from '../config.js';
import { lightType } from '../helpers/enums';


let buildBrandObjects = (benchModels) => {
    let result = {};
    benchModels.map(m => m.id).forEach(b => result[b] = "");
    return result;
}
let buildShapeObjects = (benchShapes) => {
    let result = {};
    benchShapes.map(m => m.id).forEach(b => result[b] = "");
    return result;
}
var initialState =
{
    ligths: [],
    benchBrands: buildBrandObjects(benchModels),
    benchShapes: buildShapeObjects(benchShapes),
    benchMaterials: {},
    profilePrices: {},
    glassPrice:0,
    baseOptions: {},
    activeOptions: {},
    optionRows: []

}
const optionPricing = (state = initialState, action) => {
    let options = state.activeOptions;
    let rows = {};
    switch (action.type) {
        case 'CHANGE_PANEL_MATERIAL':
            options.panel = action.id;            
            return updateOptions(state, options);   
        case 'BENCH_CHANGED':      
            options.benchBrand = action.bench.model.name;
            options.benchShape = action.bench.shape.code;
            options.benchMaterial = action.bench.material;
            options.profile = action.bench.profileMaterial;
            options.mirrored = action.bench.shape.mirrored;
            return updateOptions(state, options);      
        case 'STOVE_CHANGED':
            options.stove = action.stove;
            return Object.assign({}, state, {   
                activeOptions: options
            })
        case 'LIGHTING_CHANGED':
            options.ligth = buildLightId(action.roofLight, action.benchLight, action.stoveLight, action.fibers);
            return Object.assign({}, state, {
                activeOptions: options
            })  
        case 'BENCHBRAND_OPTIONPRICES_UPDATED':
            return Object.assign({}, state, {
                benchBrands: action.prices
            })
        case 'BENCHBRAND_OPTIONPRICES_UPDATE_STARTED':
            return Object.assign({}, state, {    
                benchBrands:[]
            })
        case 'BENCHSHAPE_OPTIONPRICES_UPDATE_STARTED':
            return Object.assign({}, state, {
                benchShapes: []
            })
        case 'BENCHSHAPE_OPTIONPRICES_UPDATED':
            return Object.assign({}, state, {
                benchShapes: action.prices
            })
        case 'BENCHMATERIAL_OPTIONPRICES_UPDATED':
            return Object.assign({}, state, {
                benchMaterials: action.prices
            })
        case 'BENCHMATERIAL_OPTIONPRICES_UPDATE_STARTED':
            return Object.assign({}, state, {
                benchMaterials: []
            })
        case 'GLASSPRICE_UPDATED':
            return Object.assign({}, state, {
                glassPrice: action.price
            })

        case 'PROFILE_OPTIONPRICES_UPDATED':
            return Object.assign({}, state, {
                profilePrices: action.prices
            })
        case 'OPTION_ROWS_UPDATED':
               return Object.assign({}, state, {
                   optionRows: action.rows
               })
        case 'PLAN_LOADED':
            {
                return Object.assign({}, state, {
                    baseOptions: planToOptions(action.plan.baseOptions),
                    activeOptions: planToOptions(action.plan)
                })   
            }
        case 'CLIENT_COFIGURATION_UPDATED':
            {
                if (action.configuration.availableStoves) {
                    let stovePrices = action.configuration.availableStoves.map(s => convertstoveId(s));
                    return Object.assign({}, state, {
                        panels: buildOptions(action.configuration.availablePanelMaterials, state.baseOptions.panel),
                        panelPrices: action.configuration.availablePanelMaterials,
                        stovePrices: stovePrices,
                        lightPrices: action.configuration.availableLigths,
                        lights: buildOptions(action.configuration.availableLigths, state.baseOptions.ligth),
                        stoves: buildOptions(stovePrices, state.baseOptions.stove)
                    })
                }
                else {
                    return state;
                }
            }
        default:
            return state;
    }
}

export default optionPricing

let convertstoveId = (stove) => {
    let internalId = stoves.find(s => s.exportID == stove.id).id;
    return {
        price: stove.price,
        id: internalId
    };
}


let planToOptions = (plan) => {
    return {
        ligth: plan.lightningType,
        stove: stoves.find(s => s.exportID === plan.stove).id,
        panel: plan.panelMaterial,
        benchBrand: plan.benchBrand,
        benchShape: plan.benchShape,
        benchMaterial: plan.benchMaterial,
        mirrored: plan.mirrored,
        profile: 1,
        benchBasePrice: plan.baseBenchPrice
    }
}

let buildLightId = (roofLight, benchLight, stoveLight,fibers) => {
    let result = lightType.NoLigthing;
    if (benchLight) {
        if (roofLight) result = lightType.BenchWithRoof;
        else if (stoveLight) result = lightType.BenchWithStove + ";" + fibers;
        else result = lightType.Bench + ";" + fibers;
    }
    else if (roofLight) {
        result = lightType.Roof
    }
    return result;
}


let buildOptions = (prices, selected) =>
{    
    let selectedPrice = prices.find((p) => p.id == selected);
    if (selectedPrice) selectedPrice = selectedPrice.price;
    else selectedPrice = 0;
    let optionPrices = {};
    prices.forEach(p => optionPrices[p.id] = p.price - selectedPrice);
    return optionPrices;
}
let updateOptions = (state, options) => {

    return Object.assign({}, state, {
        activeOptions: options
    })
}